module.exports = __webpack_public_path__ + "static/img/4.6353bbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p2/4.png
// module id = tmnz
// module chunks = 1